import faq from './../components/faq'
import './../../scss/blocks/_faq.scss'

document.addEventListener('DOMContentLoaded', () => {
    faq()
})
